var _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    viewBox: "0 0 34 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1",
    maskUnits: "userSpaceOnUse",
    x: 0.761719,
    y: 0.769287,
    width: 33,
    height: 41,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.761719,
    y: 0.769287,
    width: 33,
    height: 41
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76172 17.1313C1.76172 8.64017 8.58855 1.76929 17.0104 1.76929C25.4111 1.76929 32.2379 8.64017 32.2379 17.1313C32.2379 22.4435 29.5369 26.8121 25.5174 29.8681C21.668 32.801 19.4775 36.5544 18.2865 39.3848C17.8186 40.5128 16.181 40.5128 15.7131 39.3848C14.5222 36.5749 12.3529 32.801 8.48222 29.8681C4.46268 26.8121 1.76172 22.4229 1.76172 17.1313Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pin-bg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76172 17.1313C1.76172 8.64017 8.58855 1.76929 17.0104 1.76929C25.4111 1.76929 32.2379 8.64017 32.2379 17.1313C32.2379 22.4435 29.5369 26.8121 25.5174 29.8681C21.668 32.801 19.4775 36.5544 18.2865 39.3848C17.8186 40.5128 16.181 40.5128 15.7131 39.3848C14.5222 36.5749 12.3529 32.801 8.48222 29.8681C4.46268 26.8121 1.76172 22.4229 1.76172 17.1313Z",
    fill: "#64BEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5174 29.8681L24.9122 29.0721L24.9114 29.0727L25.5174 29.8681ZM18.2865 39.3848L17.3648 38.9969L17.3628 39.0017L18.2865 39.3848ZM15.7131 39.3848L16.6369 39.0017L16.6338 38.9945L15.7131 39.3848ZM8.48222 29.8681L7.87699 30.6642L7.87828 30.6651L8.48222 29.8681ZM17.0104 0.769287C8.02958 0.769287 0.761719 8.09459 0.761719 17.1313H2.76172C2.76172 9.18574 9.14752 2.76929 17.0104 2.76929V0.769287ZM33.2379 17.1313C33.2379 8.0955 25.9709 0.769287 17.0104 0.769287V2.76929C24.8512 2.76929 31.2379 9.18483 31.2379 17.1313H33.2379ZM26.1226 30.6642C30.3377 27.4595 33.2379 22.8172 33.2379 17.1313H31.2379C31.2379 22.0697 28.7362 26.1647 24.9122 29.0721L26.1226 30.6642ZM19.2082 39.7726C20.3554 37.0463 22.4552 33.4585 26.1235 30.6635L24.9114 29.0727C20.8808 32.1436 18.5995 36.0625 17.3648 38.9969L19.2082 39.7726ZM14.7894 39.7679C15.5985 41.7185 18.4012 41.7185 19.2102 39.7679L17.3628 39.0017C17.3031 39.1457 17.1748 39.2308 16.9998 39.2308C16.8248 39.2308 16.6966 39.1457 16.6368 39.0017L14.7894 39.7679ZM7.87828 30.6651C11.5634 33.4575 13.6428 37.0626 14.7924 39.775L16.6338 38.9945C15.4016 36.0872 13.1424 32.1446 9.08616 29.0711L7.87828 30.6651ZM0.761719 17.1313C0.761719 22.796 3.66131 27.459 7.87699 30.6642L9.08745 29.0721C5.26405 26.1652 2.76172 22.0499 2.76172 17.1313H0.761719Z",
    fill: "#192337",
    mask: "url(#path-1-outside-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.67612848b47f437dbf7753e2070ff47a.svg";
export { ForwardRef as ReactComponent };